export default __webpack_public_path__ + "static/media/black_princess.8c269251.png";